export const SET_SELECTED_MENU_ITEM = "SET_SELECTED_MENU_ITEM";
export const SET_MENU_ITEM_INDICATOR = "SET_MENU_ITEM_INDICATOR";

export function setSelectedMenuItem(menuId) {
    return {type:SET_SELECTED_MENU_ITEM, id: menuId};
}

export function getMenuNotifications() {
    return { type: SET_MENU_ITEM_INDICATOR  };
}
